'use strict'

import Swiper from '../../components/swiper'

export default class Sustainability {
  constructor() {
    this.$elem = $('.Sustainability')

    if (this.$elem.length > 0) {
      let self = this

      $(document).ready(function () {
        if (self.$elem.hasClass('Page')) {
          self.slideElements = {}
          self._eleemnts()
          self.$slideReports = {}
          self._reports()
        }

        if (self.$elem.hasClass('Single')) {
          self.changing = false
          self._tabs()
        }
      })
    }
  }

  _eleemnts(){
    let self = this
    let $sidebar = $('.Page.Sustainability .Sidebar')
    let $mainContainer = $('.Sustainability__container')
    
    let resizerBox = () => {
        if( window.innerWidth >= 1200 ){
            if( $mainContainer.hasClass('-full') ){
                $mainContainer.removeClass('-full')
            }
            
            let valueWidth = 0
            if( !$sidebar.hasClass('show_complete') ){
                valueWidth = window.innerWidth - 70
            } else{
                valueWidth = window.innerWidth - $sidebar.outerWidth()
            }

            $mainContainer.css({
                'max-width' : valueWidth
            })
            
        } else{
            if( !$mainContainer.hasClass('-full') ){
                $mainContainer.addClass('-full', 300, 'swing')
            }
        }
    }
    resizerBox()
    
    let $items = $mainContainer.find('.item')
    let itemsToShow = 0

    let generatorSlide = () => {
      if (window.innerWidth >= 900) {
        itemsToShow = 3
      } else {
        if (window.innerWidth >= 500) {
          itemsToShow = 2
        } else {
          itemsToShow = 1
        }
      }

      if ($items.length <= itemsToShow) {
        $mainContainer.addClass('without-slide grid-noGutter-justify-top')
        $items.addClass('col')
        return false
      }

      $items.addClass('swiper-slide')
      $mainContainer.addClass('with-slide')
      $mainContainer.append('<div class="swiper-wrapper"></div>')
      let $container = $mainContainer.find('.swiper-wrapper')
      $mainContainer.append(`<a class="buttons_controls prev swiper-button-prev"></a>`)
      $mainContainer.append(`<a class="buttons_controls next swiper-button-next"></a>`)

      $.each($items, function (i, val) {
        $container.append($(this))
      })

      this.slideElements = new Swiper('.Sustainability__container', {
        nextButton: '.Sustainability__container .swiper-button-next',
        prevButton: '.Sustainability__container .swiper-button-prev',
        slidesPerView: itemsToShow,
        mousewheelControl: true
      })
    }
    generatorSlide()

    let minHeight = $items.first().find('.item_thumb').outerHeight()
    $.each($items, function (i, val) {
      if ($(this).find('.item_thumb').outerHeight() < minHeight) {
        minHeight = $(this).find('.item_thumb').outerHeight()
      }

      if (i + 1 == $items.length) {
        $('.Sustainability__container').css({
          'height': minHeight
        })

        var resizeAgain = function (value) {
          setTimeout(function () {
            $('.Sustainability__container').css({
              'height': value
            })
          }, 500)
        }
        resizeAgain(minHeight)
      }
    })
    
    $(window).resize(() => {
      resizerBox()
      if (!$.isEmptyObject(self.slideElements)) {
        let itemsToShow = 0

        if (window.innerWidth >= 900) {
          itemsToShow = 3
        } else {
          if (window.innerWidth >= 500) {
            itemsToShow = 2
          } else {
            itemsToShow = 1
          }
        }

        if (self.slideElements.params.slidesPerView != itemsToShow) {
          self.slideElements.params.slidesPerView = itemsToShow
        }

        self.slideElements.update()
      } else {
        generatorSlide()
      }
    })

    $(window).on("orientationchange", () => {
      resizerBox() 
      if (!$.isEmptyObject(self.slideElements)) {
        let itemsToShow = 0

        if (window.innerWidth >= 900) {
          itemsToShow = 3
        } else {
          if (window.innerWidth >= 500) {
            itemsToShow = 2
          } else {
            itemsToShow = 1
          }
        }

        if (self.slideElements.params.slidesPerView != itemsToShow) {
          self.slideElements.params.slidesPerView = itemsToShow
        }

        self.slideElements.update()
      } else {
        generatorSlide()
      }
    })
  }

  _reports(){
    let self = this

    self.$slideReports = new Swiper('.Sustainability__reports .reports', {
      slidesPerView: 'auto',
      prevButton: '.Sustainability__reports .reports .buttons_controls.prev',
      nextButton: '.Sustainability__reports .reports .buttons_controls.next',
      mousewheelControl: true,
      spaceBetween: 40
    })

    $(window).resize(() => {
      if (!$.isEmptyObject(self.$slideReports)) {
        self.$slideReports.update()
      }
    })

    $(window).on("orientationchange", () => {
      if (!$.isEmptyObject(self.$slideReports)) {
        self.$slideReports.update()
      }
    })
  }

  _tabs(){
    let self = this
    let $tabs = $('.Sustainability__container__header .tab_item a')

    $tabs.on('click', function (event) {
      if ($(this).hasClass('active') || self.changing) { return }

      self.changing = true

      let sectionToActivate = $(this).parent().attr('data-section')
      $(this).parent().siblings().find('.active').removeClass('active')
      $(this).addClass('active')

      let $body = $("html, body")
      var valueTop = window.innerWidth >= 768 ? $('.Sustainability__container__results').offset().top - 130 : $('.Sustainability__container__results').offset().top - $('#header').outerHeight();
        $body.stop().animate({ scrollTop: valueTop }, '500', 'swing', function () { })

      let $lastSection = $('.container_result.active')
      let $currentSection = $(`.container_result[data-section="${sectionToActivate}"]`)

      $('body').css({
        'height': $('body').outerHeight()
      })

      $lastSection.fadeOut(function () {
        $lastSection.removeClass('active')
        $currentSection.fadeIn(function () {
          $currentSection.addClass('active').removeAttr('style')
          $('body').css({ 'height': 'auto' })
          self.changing = false
        })
      })
    })
  }
}

